import React from 'react';
import './App.css';
import router from './router';
import { RouterProvider } from 'react-router';
import StarryBackground from './Components/StarryBackground/StarryBackground';

// Separate the content into its own component
const Content = () => (
  <div className="content">
    <div className="App-body">
      <RouterProvider router={router} />
    </div>
    <footer className="App-footer">
      <p>&copy; 2025 Dustin Graham. All rights reserved.</p>
    </footer>
  </div>
);

function App() {
  return (
    <div className="App">
      <StarryBackground />
      <Content />
    </div>
  );
}

export default App;
